export class Constants {

  public static DATASET_DEFAULT: string = 'discariche';
  public static DATASET_DISCARICHE: string = 'discariche';
  public static DATASET_TERREMOTI: string = 'terremoti';
  public static DATASET_METEO: string = 'meteo';

  public static FILTER_WIDGET: string = 'widget filter';
  public static FILTER_WMS_WIDGET: string = 'widget WMS filter';
  public static FILTER_INTEGRATION: string = 'integration filter';

  public static TIMELINE_WIDGET: string = 'widget timeline';
  public static FILTER_TYPE: string = 'timeline';
  public static LIST_TYPE: string = 'list';
  public static WMS_LIST_TYPE: string = 'wms-list';
  public static INTEGRATION_TYPE: string = 'integration';

  public static RANGE_TYPE: string = 'range';
  public static LAYER_TYPE_TileWMS: string = 'TileWMS';
  public static LAYER_TYPE_ImageWMS: string = 'ImageWMS';
  public static LAYER_TYPE_VECTOR: string = 'VECTOR';
  public static LAYER_TYPE_XYZ: string = 'XYZ';
  public static AGGREGATION_TYPE_POINT: string = 'POINT';
  public static AGGREGATION_TYPE_HEXAGON: string = 'HEXAGON';
  public static NOT_SAVED_GEOMETRY_REPORT = -1;
  public static GEOMETRY_TYPE_POINT = "POINT";
  public static GEOMETRY_TYPE_POLYGON = "POLYGON";
  public static GEOMETRY_TYPE_LINE = "LINESTRING";
  public static GEO_FILTER_TYPE_SELECTION = "SELECTION";
  public static GEO_FILTER_TYPE_FILTER = "FILTER";
  public static GEO_FILTER_TYPE_NULL = null;
  
  public static FEATURE_INFO_FORMAT_JSON = "application/json";
  public static FEATURE_INFO_FORMAT_HTML = "text/html";

  public static ERRORE_GENERICO = "Si è verificato un errore";



}